/**
 * Returns the scroll container in the document view.
 *
 * This can be used to scroll to specific elements inside the document.
 */
export function getScrollContainer() {
  return document.getElementById('document-reader-root');
}
